import type { MedalTier } from "@dailywars/core/medals";

import { ChallengeStarCount } from "#/components/ChallengeStarIcon";
import { MedalIcon } from "#/components/MedalIcon";
import { Skeleton } from "#/components/ui/skeleton";

const MEDAL_ORDER: readonly MedalTier[] = ["gold", "silver", "bronze"];

export function ProfileMedalsBadges({
  goldMedals,
  silverMedals,
  bronzeMedals,
  challengeStars,
}: {
  goldMedals: number;
  silverMedals: number;
  bronzeMedals: number;
  challengeStars: number;
}) {
  const counts: Record<MedalTier, number> = {
    gold: goldMedals,
    silver: silverMedals,
    bronze: bronzeMedals,
  };

  return (
    <div className="flex items-center gap-4">
      {MEDAL_ORDER.map((tier) => (
        <span
          key={tier}
          className="inline-flex items-center gap-1.5 text-base font-medium tabular-nums text-foreground"
        >
          <MedalIcon tier={tier} size={28} />
          <span>{counts[tier]}</span>
        </span>
      ))}
      <ChallengeStarCount count={challengeStars} size={28} className="gap-1.5 text-base" />
    </div>
  );
}

export function ProfileMedalsBadgesSkeleton() {
  return (
    <div className="flex items-center gap-4">
      {MEDAL_ORDER.map((tier) => (
        <Skeleton key={tier} className="h-7 w-14" />
      ))}
      <Skeleton className="h-7 w-14" />
    </div>
  );
}
